import React from 'react'
import CookieConsent from 'react-cookie-consent';

const CookieBanner = () => {
    return (
        <>
            <CookieConsent
                // documentation: https://www.npmjs.com/package/react-cookie-consent
                location="bottom"
                buttonText="GOT IT"
                cookieName="KidstonGDPR"
                style={{
                    background: '#77b7be',
                }}
                buttonStyle={{
                    background: '#101010',
                    color: '#fff',
                    fontFamily: 'work-sans, Helvetica Neue, Helvetica, sans-serif',
                    fontSize: 'md',
                    fontWeight: 'semibold',
                }}
                expires={150}
            >
                This website uses cookies to enhance the user experience.{' '}
            </CookieConsent>
        </>
    )
}

export default CookieBanner
